type Ethnicity = {
	uuid: string;
	label: string;
	value: string;
};

export const ethnicities: Ethnicity[] = [
	{
		uuid: "9e67d1f1-32f7-4691-b36c-cfa9e1454d37",
		label: "African",
		value: "AFRICAN",
	},
	{
		uuid: "9e67d1f1-3309-45b5-adca-d0b2c4b65c66",
		label: "Arab",
		value: "ARAB",
	},
	{
		uuid: "9e67d1f1-330d-4a81-ad9b-53e293687e49",
		label: "Asian",
		value: "ASIAN",
	},
	{
		uuid: "9e67d1f1-3310-4d4f-8694-40d5c6b35d40",
		label: "Caucasian",
		value: "CAUCASIAN",
	},
	{
		uuid: "9e67d1f1-3312-4602-9fa5-e0f1945d3551",
		label: "East Asian",
		value: "EAST ASIAN",
	},
	{
		uuid: "9e67d1f1-3314-4a9d-9dc0-928f72b1ed5d",
		label: "European",
		value: "EUROPEAN",
	},
	{
		uuid: "9e67d1f1-3316-4fbc-a96e-f116f0f48f4a",
		label: "Indigenous American",
		value: "INDIGENOUS AMERICAN",
	},
	{
		uuid: "9e67d1f1-3318-4302-a827-52ae1a49636b",
		label: "Latino",
		value: "LATINO",
	},
	{
		uuid: "9e67d1f1-331a-41c7-b479-a91695586d56",
		label: "Middle Eastern",
		value: "MIDDLE EASTERN",
	},
	{
		uuid: "9e67d1f1-331b-405a-ab41-75d13dbd6e1c",
		label: "Native Hawaiian",
		value: "NATIVE HAWAIIAN",
	},
	{
		uuid: "9e67d1f1-331d-4d46-be30-c235c872130f",
		label: "South Asian",
		value: "SOUTH ASIAN",
	},
	{
		uuid: "9e67d1f1-331f-485e-94d4-6c2e48fc047a",
		label: "Southeast Asian",
		value: "SOUTHEAST ASIAN",
	},
	{
		uuid: "9e67d1f1-3321-40b0-8916-81d903d42255",
		label: "Sub-Saharan African",
		value: "SUB-SAHARAN AFRICAN",
	},
];
